import { useEffect } from 'react';
import { Task } from '@/api';
import { FetchTasksQuery, useFetchTasks } from './use-fetch-tasks';

/**
 * `useFetchTasks`, paged all the way through. For the callers that need every
 * task matching the query at once — the dashboard and the unassigned alerts —
 * rather than a list the viewer scrolls.
 */
export function useFetchAllTasks(query: FetchTasksQuery): {
    tasks: Task[];
    status: 'error' | 'success' | 'pending';
} {
    const { tasks, status, hasNextPage, isFetchingNextPage, fetchNextPage } =
        useFetchTasks(query);

    useEffect(() => {
        if (!isFetchingNextPage && hasNextPage) {
            fetchNextPage();
        }
    }, [isFetchingNextPage, hasNextPage, fetchNextPage]);

    return {
        tasks,
        status
    };
}
